module.exports = __webpack_public_path__ + "1759da024c4272bb6d3b05661d7f9997.svg";